import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { Grid, GridSize } from '@material-ui/core';
import './Skeleton.css';

/*
SKELETON COMPONENT TO RENDER INSTEAD OF TABLES WHEN LOADING.
To modify space distribution on the columns, add more cases in 'if' statement.
*/

interface PROPS {
  columns: string[];
  rows: number[];
}

const CustomSkeleton = ({ columns, rows }: PROPS): JSX.Element => {
  let columnsSize: GridSize;

  if (columns.length === 3) {
    columnsSize = 4;
  } else if (columns.length === 2) {
    columnsSize = 6;
  } else if (columns.length === 5 || columns.length === 6) {
    columnsSize = 2;
  } else if (columns.length >= 7) {
    columnsSize = 1;
  } else {
    columnsSize = 3;
  }

  return (
    <Grid container spacing={0}>
      <Grid container>
        {columns.map((col) => (
          <Grid
            item
            xs={columnsSize}
            key={`${col}/${Math.random()}`}
            className={columnsSize === 2 || columnsSize === 1 ? 'fix-width-grow' : ''}
          >
            <div className="skeleton-header">{col}</div>
          </Grid>
        ))}
      </Grid>
      {rows.map((_, i) => (
        <Grid
          container
          spacing={0}
          style={{
            border: '1px solid #dee2e6',
            backgroundColor: i % 2 === 0 ? 'rgba(0,0,0,.075)' : 'white',
          }}
          key={`Row/${i}/${Math.random()}`}
        >
          {columns.map((_, i, arr) =>
            arr.length - 1 > i ? (
              <Grid
                item
                xs={columnsSize}
                key={Math.random() + i}
                className={columnsSize === 2 || columnsSize === 1 ? 'fix-width-grow' : ''}
              >
                <div className="skeleton-footer border-right">
                  <Skeleton variant="rect" animation="wave" component="h5" />
                </div>
              </Grid>
            ) : (
              <Grid
                item
                xs={columnsSize}
                key={Math.random() + i}
                className={columnsSize === 2 || columnsSize === 1 ? 'fix-width-grow' : ''}
              >
                <div className="skeleton-footer">
                  <Skeleton variant="rect" animation="wave" component="h5" />
                </div>
              </Grid>
            ),
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default CustomSkeleton;
